/**
 * nav-config.ts — primary sidebar navigation declaration.
 *
 * Per ui-design.md §4.3, items are visibility-gated by permission. Pure data;
 * the Sidebar component filters by the user's effective permissions.
 */

export interface NavItem {
  to: string;
  labelKey: string;
  /** If set, item only shows when the user holds this permission. */
  requiresPermission?: string;
  /** End-only match — '/' shouldn't be active when the URL is '/team'. */
  end?: boolean;
}

export const PRIMARY_NAV: readonly NavItem[] = [
  { to: '/', labelKey: 'Home', end: true },
  { to: '/team', labelKey: 'Team' },
  { to: '/jobs', labelKey: 'Jobs' },
  { to: '/activity', labelKey: 'Activity' },
];

export const ACCOUNT_NAV: readonly NavItem[] = [
  {
    to: '/library',
    labelKey: 'Library',
    requiresPermission: 'manage_library',
  },
  { to: '/connectors', labelKey: 'Connectors' },
  { to: '/settings', labelKey: 'Settings' },
];
